<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col cols="12">
        <v-card>
          <v-card-title>
            Activate MH1 with {{pmsConnDetails.usr}}
            <v-spacer></v-spacer>
            <v-scale-transition>
              <v-chip right class="ma-2" color="orange" text-color="white" v-show="isDirty">
                Changes Pending
              </v-chip>
            </v-scale-transition>
          </v-card-title>
          <v-card-subtitle>
            {{pmsConnDetails.pmsType}} | PMS Information retrieved:
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <timeago :datetime="pmsInfo.ctdTs" :auto-update="60"></timeago>
                </span>
              </template>
              <span>{{new Date(pmsInfo.ctdTs)}}</span>
            </v-tooltip>
          </v-card-subtitle>

          <v-spacer></v-spacer>

          <v-card-actions></v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-stepper :value="activeStep" :vertical="true" non-linear>
          <template v-for="(step,index) in steps">
            <v-stepper-step
              :name="step.name"
              :step="index+1"
              :key="index+'_Header'"
              :editable="step.editable"
              :complete="step.complete"
              edit-icon="$complete"
            >
              {{step.title}}
              <small>{{step.subtitle}}</small>
            </v-stepper-step>
            <v-stepper-content :step="index+1" :key="index+'_Content'">
              <component
                :is="step.content"
                :pmsInfo="pmsInfo"
                :index="index+1"
                @change-step="activeStep = index"
                v-on:step-is-valid="step.isValid=$event"
                v-model="addMh1Context"
              ></component>
              <v-btn right @click="nextStep(step, index)" color="primary" :disabled="false">Continue</v-btn>
              <v-btn v-if="activeStep > 1" @click="activeStep--" color="normal">Back</v-btn>
            </v-stepper-content>
          </template>

          <v-stepper-step
            name="Finalise"
            :step="steps.length+1"
            :key="(steps.length+1)+'_Header'"
          >Finalise</v-stepper-step>
          <v-stepper-content :step="steps.length+1">
            <v-btn
              right
              :disabled="!isDirty"
              color="primary"
              @click="publishChanges()"
              :loading="publishChangesBusy"
            >Publish Changes</v-btn>

            <v-alert v-if="finished" type="info">
                All done! You may want to go: <v-btn :to="{ name: 'PmsConnProducts', params: { sub: $route.params.sub}}">Back to Products</v-btn>
            </v-alert>
          </v-stepper-content>
        </v-stepper>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-divider></v-divider>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { API, graphqlOperation } from "aws-amplify";
import * as queries from "@/graphql/queries";
import * as mutations from "@/graphql/mutations";

import SelectSite from "./mh1/SelectSite";
import ChooseNewOrExisting from "./mh1/ChooseNewOrExisting";
import PracticeDetails from "./mh1/PracticeDetails";
import ManageTreatments from "./mh1/ManageTreatments";
import SelectBooks from "./mh1/SelectBooks";
import ManageBooks from "./mh1/ManageBooks";
import SelectFeatures from "./mh1/SelectFeatures";
import Maintenance from "./mh1/Maintenance";

export default {
  props: {
    pmsConnDetails: Object,
    pmsInfo: Object,
    pmsInfoLoading: Boolean,
  },
  created: async function () {
    window.addEventListener("beforeunload", this.beforeWindowUnload);

    const sub = this.$route.params.sub;
    console.log("created", sub);
    await this.getLinks(sub);
    if (this.pmsInfo?.sites?.length == 1) {
      this.addMh1Context.selectedSiteId = this.pmsInfo.sites[0].pmsSiteId;
    }
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.beforeWindowUnload);
  },
  watch: {
    addMh1Context: {
      handler(newVal, oldVal) {
        console.log("watch addMh1Context handler", newVal, oldVal);
        if (this.dirtyStateReset) {
          console.log(
            "watch addMh1Context handler ignoring change, stateReset true"
          );
          this.dirtyStateReset = false;
          return;
        }

        this.isDirty = true;
        console.log("watch addMh1Context handler set dirty");
      },
      deep: true,
    },
  },
  async beforeRouteLeave(to, from, next) {
    console.log("beforeRouteLeave");
    const proceed = await this.confirmLeaveIfDirty();

    if (proceed) {
      next();
    } else {
      next(false);
    }
  },
  computed: {
    steps: function () {
      const selectSiteTitle =
        this.pmsInfo?.sites?.length > 1
          ? "Select PMS Site"
          : "Review PMS Site Information";
      return [
        {
          name: "selectPMSSite",
          title: selectSiteTitle,
          subtitle: "",
          content: SelectSite,
        },
        {
          name: "newOrExistingMh1Practice",
          title: "New or Existing MyHealth1st Practice",
          subtitle: "",
          content: ChooseNewOrExisting,
        },
        {
          name: "practiceDetails",
          title: "MyHealth1st Practice Details",
          subtitle: "",
          content: PracticeDetails,
        },
        {
          title: "Sync Settings",
          subtitle: "",
          content: SelectFeatures,
        },
        {
          title: "Select Books to Synchronize",
          subtitle: "",
          content: SelectBooks,
        } /*
        {
          title: "Manage Treatments",
          subtitle: "",
          content: ManageTreatments,
        },*/,
        {
          title: "Setup Syncrhonized Books",
          subtitle: "",
          content: ManageBooks,
        } /*,
        {
          title: "Automatic Maintenance",
          subtitle: "",
          content: Maintenance,
        },*/,
      ];
    },
  },
  data: function () {
    return {
      addMh1Context: {
        products: ["olb","mh1EasyRecalls"],
        selectedSiteId: "",
        newOrExisting: "new",
        links: {},
        username: "",
        encryptedPassword: "",
        timeZone: "",
        notificationChannel: "",
        features: {
          mh1EasyRecalls: {
            pmsSiteId: ""
          }
        }
      },
      activeTab: 0,
      activeStep: 1,
      isDirty: false,
      dirtyStateReset: true,
      isLoading: false,
      publishChangesBusy: false,
      mh1BaseUri: process.env.VUE_APP_MH1_BASE_URI,
      finished: false
    };
  },
  methods: {
    nextStep: function (step, index) {
      step.editable = true;
      step.complete = true;
      this.activeStep = index + 2;
    },
    tabClick: function () {
      return false;
    },
    beforeWindowUnload(e) {
      if (this.isDirty) {
        e.preventDefault();
        e.returnValue = "";
      }
    },
    async publishChanges() {
      this.publishChangesBusy = true;
      try {
        console.log(
          "publishChanges addMh1Context.links",
          this.addMh1Context.links
        );
        console.log("publishChanges addMh1Context", this.addMh1Context);

        const links = this.addMh1Context.links;

        if (
          this.addMh1Context.newOrExisting == "new" ||
          !this.addMh1Context.existingMh1PracticeId
        ) {
          console.log(
            "publishChanges newAccount",
            this.addMh1Context.newOrExisting,
            this.addMh1Context.existingMh1PracticeId
          );
          this.$dialog.error({
            text:
              "Only using an existing MH1 Practice is supported at this time.",
          });
          return;
        }

        const foundAccount = links.accounts.find(
          (acc) =>
            acc.platform == "mh1" &&
            acc.accountId == this.addMh1Context.existingMh1PracticeId
        );

        if (foundAccount) {
          console.log("publishChanges foundAccount", foundAccount);
          this.$dialog.error({
            text:
              "This MH1 account is already configured for this PMS Connector.",
          });
          return;
        }
        /*
        this.addMh1Context.newOrExisting; // "new" | "existing"
        this.addMh1Context.existingMh1PracticeId;
        this.addMh1Context.existingMh1Practice;
        this.addMh1Context.features; // string[]
*/
        // MH1 Hub Api calls for each sync'd book set pmsPractitionerCode / pmsLocation
        for (const item of this.addMh1Context.pmsBooksToSync) {
          console.log("set mh1 sync values for ", item);
          if (item.newOrExisting == "new" || !item.selectedMh1BookId) {
            console.log(
              "publishChanges newBook",
              item.newOrExisting,
              item.selectedMh1BookId,
              item
            );
            this.$dialog.error({
              text:
                "Only using an existing MH1 Book is supported at this time.",
            });
            return;
          }

          const parts = item.book.pmsBookFQId.split("::");

          const locationId = parts.length > 1 ? parts[0] : "";

          const practitionerCode =
            parts.length > 1
              ? parts.splice(1).join("::")
              : item.book.pmsBookFQId;

          try {
            // MH1 Hub Api calls for each sync'd book set pmsPractitionerCode / pmsLocation

            console.log(
              "stubCall setMh1PractitionerCode",
              item.selectedMh1BookId,
              practitionerCode,
              locationId,
              parts,
              item
            );
            
            const setMh1PractitionerCodeResult = await API.graphql(
              graphqlOperation(mutations.setMh1PractitionerCode, {
                appointmentBookId: item.selectedMh1BookId,
                practitionerCode,
                locationId,
              })
            );

            console.log("got setMh1PractitionerCodeResult", item.selectedMh1BookId, practitionerCode, locationId, setMh1PractitionerCodeResult);
            
          } catch (err) {
            console.log(
              "publishChanges setMh1PractitionerCode err",
              item.selectedMh1BookId,
              item.book.pmsBookFQId,
              practitionerCode,
              locationId,
              err
            );
            await this.handleResponseError(
              "Error Updating MH1 Appointment Book Pracitioner/Location Codes",
              err
            );
            return;
          }
        }

        const olbBooks = [];

        for (const item of this.addMh1Context.pmsBooksToSync) {
          /*
          item.action; //"ok"
          item.newOrExisting; // "existing" | "new"
          item.selectedMh1BookId;
          item.book.pmsBookFQId;
*/

          const treatmentMappings = [];

          for (const itemMapping of (item.mappings ?? [])) {
            treatmentMappings.push({
              olbTreatmentId: itemMapping.mh1TreatmentId.toString(),
              pmsAppointmentTypeId: itemMapping.pmsAppointmentTypeId,
            });
          }

      const appointmentTypes = [];

           for (const type of item.appointmentTypes ?? []) {
            appointmentTypes.push({
              name: type.name,
            });
          }
          const olbBook = {
            olbBookId: item.selectedMh1BookId,
            pmsBookFQId: item.book.pmsBookFQId,
          };

          if (treatmentMappings.length > 0) {
            olbBook["treatmentMappings"] = treatmentMappings;
          }
        if (appointmentTypes.length > 0) {
            olbBook["appointmentTypes"] = appointmentTypes;
          }
          olbBooks.push(olbBook);
        }
        const newAccount = {
          accountId: this.addMh1Context.existingMh1PracticeId,
          baseUrl: this.mh1BaseUri,
          encryptedPassword: this.addMh1Context.encryptedPassword,
          notificationChannel: this.addMh1Context.notificationChannel,
          olbBooks,
          platform: "mh1",
          products: this.addMh1Context.products,
          timeZone: this.addMh1Context.timeZone,
          username: this.addMh1Context.username,
          primaryPmsSiteId: this.addMh1Context.selectedSiteId,
        };

        if (this.addMh1Context.products.find((p) => p?.toLowerCase() ?? "" === "mh1easyrecalls")) {
          newAccount.mh1EasyRecalls = {
            pmsSiteId:
              this.addMh1Context.features?.mh1EasyRecalls?.pmsSiteId ?? "",
          };
        }

        links.accounts.push(newAccount);

        links.accCount = links.accounts.length;

        try {
          console.log("stubCall updateLinks with", links);
          
        const updateLinksResult = await API.graphql(
          graphqlOperation(mutations.updateLinks, { input: links })
        );

                console.log("Product added result", updateLinksResult);

        this.addMh1Context.links = updateLinksResult.data.updateLinks;

          this.$dialog.notify.info("Product added");
        } catch (err) {
          console.log("Product added error", err);

          const notifyResult = await this.$dialog.notify.error(
            "Error Adding Product account",
            {
              position: "top-right",
              timeout: 5000,
              actions: [{ text: "Info", "x-small": true, color: "secondary" }],
            }
          );

          if (notifyResult == "Info") {
            this.$dialog.error({
              text: JSON.stringify(err),
              title: "Cannot save links",
              icon: "mdi-error",
            });
          }
        }
        this.dirtyStateReset = true;
        this.isDirty = false;       
        this.finished = true; 
      } finally {
        this.publishChangesBusy = false;
      }
    },

    async handleResponseError(operationDescription, response) {
      console.log("handleResponseError", response);
      const notifyResult = await this.$dialog.notify.error(
        operationDescription,
        {
          position: "top-right",
          timeout: 5000,
          actions: [{ text: "Info", "x-small": true, color: "secondary" }],
        }
      );

      if (notifyResult == "Info") {
        this.$dialog.error({
          text: JSON.stringify(response?.errors || response),
          title: operationDescription,
          icon: "mdi-error",
        });
      }
    },
    async confirmLeaveIfDirty() {
      if (!this.isDirty) return true;

      const res = await this.$dialog.warning({
        text:
          "Your pending changes have not been saved. Are you sure you want to leave?",
        title: "Warning",
        icon: "mdi-alert",
      });

      if (res) {
        return true;
      } else {
        return false;
      }
    },
    async getLinks(sub) {
      this.isLoading = true;
      try {
        // Simple query
        //const allStatus = await API.graphql(graphqlOperation(queries.listStatus));
        console.log("getLinks called", sub);
        const status = await API.graphql(
          graphqlOperation(queries.getLinks, { sub: sub })
        );

        console.log("getLinks returned", status);

        if (!status.data?.getLinks?.sub) {
          console.log("getlinks did not get valid links", status);
        }

        const result = status.data?.getLinks || {
          sub: sub,
          accCount: 0,
          ctd: new Date().toString(),
          ctdTs: +new Date(),
          accounts: [],
        };

        this.addMh1Context.links = result;

        // copy obj for ref
        this.linksUnchanged = JSON.parse(JSON.stringify(result));

        this.linksStateReset = true;
        this.linksDirty = false;
      } catch (err) {
        console.log("getLinks err", err);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>